module.exports = __webpack_public_path__ + "static/3-051bea15492b828c0b82dda3594fd1c8.jpg";